export const customerContractCard = {
  contractNumber: "Kundavtal #",
  profession: "Yrke",
  aoes: "Område",
  specializations: "Nisch",
  startDate: "Startdatum",
  endDate: "Slutdatum",
  currentEnd: "Maximal avtalstid",
  priceAdjustmentDate: "Prisjusteringsdatum",
  priceAdjustmentDateDeadline: "Påminnelsedatum prisjustering",
  prolongationDate: "Förlängningsdatum",
  prolongationDateDeadline: "Påminnelsedatum förlängning",
  introductionInfo: "Introduktion"
};
